import HttpService from '../../core/services/HttpService';
import {identity} from '../../core/auth/identityAuth';

const httpService = HttpService.Instance;

async function handlePossibleAPIErrors(response: Response) {
  if (response.ok) {
    return;
  }

  let body;
  try {
    body = await response.json();
  } catch { /* @ts-ignore */ }

  if (body && body.error) {
    throw new Error(body.error);
  }
  throw new Error(response.statusText);
}

class DataSharingService {
  public static async GetDataUserAgreements(assetId: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL +
        'sharing/agreements' +
        '?assetId=' +
        assetId +
        '&subscriberId=' +
        identity['nxt:entity:id']
    );

    await handlePossibleAPIErrors(response);

    const body = await response.json();
    return body.agreements;
  }

  public static async GetDataProviderAgreements(assetId: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL +
        'sharing/agreements' +
        '?assetId=' +
        assetId +
        '&providerId=' +
        identity['nxt:entity:id']
    );

    await handlePossibleAPIErrors(response);

    const body = await response.json();
    return body.agreements;
  }

  public static async GetAgreementDetails(agreementId: string) {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + 'sharing/agreements/' + agreementId
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async PostAgreementStateChange(
    agreementId: string,
    stateId: string,
    currency: string,
    remark?: string,
    fees?: any,
    durationMonths?: number
  )
  {
    const payload: any = {
      stateId,
      currency
    };

    if (remark) {
      payload.remark = remark;
    }

    if (fees) {
      payload.fees = Object.values(fees).map((fee: any) => ({
        feeCode: fee.id,
        amount: Number(fee.data),
      }));
    }

    if (durationMonths !== undefined) {
      payload.durationMonths = Number(durationMonths);
    }

    const response = await httpService.post(
      process.env.REACT_APP_API_URL + 'sharing/agreements/' + agreementId,
      payload
    );
    
    await handlePossibleAPIErrors(response);

    return response.json();
  }
}

export default DataSharingService;



// WEBPACK FOOTER //
// ./src/modules/shared/services/DataSharingService.tsx